// A hidden page may be unloading. Rotating its token can invalidate the token
// that the next page reads before this page has saved the refresh response.
export function startSessionLifecycle(restore) {
    const restoreIfVisible = () => {
        if (document.visibilityState === 'visible') void restore(false);
    };
    const syncSession = (event) => {
        if (event.type !== 'storage' || event.key === null || ['cosToken', 'cosSessionEpoch', 'cosSessionId'].includes(event.key)) {
            restoreIfVisible();
        }
    };
    // Let refreshSession reuse a healthy access token, including after navigation.
    void restore(false);
    const interval = window.setInterval(restoreIfVisible, 60_000);
    window.addEventListener('focus', restoreIfVisible);
    window.addEventListener('storage', syncSession);
    window.addEventListener('cos-auth-changed', syncSession);
    document.addEventListener('visibilitychange', restoreIfVisible);
    return () => {
        window.clearInterval(interval);
        window.removeEventListener('focus', restoreIfVisible);
        window.removeEventListener('storage', syncSession);
        window.removeEventListener('cos-auth-changed', syncSession);
        document.removeEventListener('visibilitychange', restoreIfVisible);
    };
}
